<template>
	<div>
		<div class="dashboard">
			<ExpireMessage />
			<div class="dashboard__block">
				<h3>Информация по движению ТМЦ и ОС в {{ this.USER.ouser.kmg_dzo.name }}  <span v-if="year">за {{ year  }} г.</span></h3>
				<summary-table v-if="this.USER.ouser.for_tmz" @yearChanged="yearChanged" />
			</div>

			<div class="dashboard__block">
				<h3>Информация о ценах реализации черного и цветного металлолома по группе компаний КМГ</h3>
				<report-table class="dashboard__block__report-table" v-if="this.USER.ouser.for_report" />
			</div>
		</div>
	</div>
</template>

<script>
import { ru } from 'vuejs-datepicker/dist/locale';
import ExpireMessage from '../components/ExpireMessage.vue';
import SummaryTable from "@/components/summaryTable/SummaryTable";
import ReportTable from "@/components/home/ReportTable";

import axios from 'axios';
import {mapGetters} from "vuex";
import NProgress from "nprogress";
import store from "@/store";
export default {
	name: 'Home',
	components: {
		ExpireMessage,
    SummaryTable,
		ReportTable
	},
	data() {
		return {
			ru,
			realizationOptions: {
				responsive: true,
				maintainAspectRation: true,
			},
			dzoList: [],
			dzoListShorten: [],
			showMoreData: false,
      year: ''
		};
	},
  beforeRouteEnter(to, from, next) {
    NProgress.start();
    store.dispatch('getAllDzo', to.params.id).then(response => {
      NProgress.done();
      next();
    });
  },
  computed: {
    ...mapGetters(['USER']),
  },
	methods: {
    yearChanged (year) {
      this.year = year
    }
	},
	mounted() {
		axios.get('/auth/kmg_dzo/').then(response => {
			this.dzoList = response.data;
			this.dzoListShorten = response.data.slice(0, 5);
		});
	},
};
</script>

<style scoped lang="scss">
/* Dashboard */
.dashboard {
	background-color: #f8f8fb;
	min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

	&__block {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 2rem 0;

    &__report-table {
      margin-bottom: 10rem;
    }

		h3 {
			font-size: 20px;
			font-weight: 500;
		}
	}
}

.dashboard-container {
	padding: 2rem;
	display: grid;
	grid-template-areas:
		'bar1 bar2'
		'areaChart areaChart';
	gap: 1rem;
}

.dashboard-row {
	display: grid;
	grid-template-columns: 1fr 1fr 2fr;
	padding: 2rem;
	gap: 1.5rem;
	/* margin-bottom: 2rem; */
}

.dashboard-row.second-block {
	grid-template-columns: 2fr 1fr;
	padding: 2rem;
	gap: 1.5rem;
	/* margin-bottom: 2rem; */
}

.dashboard-row.third-block {
	grid-template-columns: 1fr 2fr;
	padding: 2rem;
	gap: 1.5rem;
	/* margin-bottom: 2rem; */
}

.dashboard-item {
	background: #fff;
	min-width: 300px;
	min-height: 300px;
	border-radius: 15px;
	/* box-shadow: 4px 4px 2px 4px rgba(0, 0, 0, 0.2),
  4px 4px 4px 4px rgba(0, 0, 0, 0.19); */
	padding: 1rem;
}

.dashboard-chart-title {
	text-align: center;
}

.dashboard-item.statistics-status {
	background-color: white;
	height: 100%;
	width: 100%;
	grid-area: bar1;
}

.dashboard-item.statistics-days-left {
	grid-area: bar2;
}

.dashboard-item.statistics-gist {
	grid-area: areaChart;
}

.calendar {
	/* display: flex; */
	/* justify-content: center; */
}

.vdp-datepicker__calendar {
	border: none !important;
	margin: 0 auto;
	width: 100%;
}

.calendar-actions {
	display: flex;
	flex-direction: column;
}

.calendar-action-btn {
	padding: 0.9rem 2rem;
	background: #f3f5ff;
	border-radius: 10px;
	border: none;
	outline: none;
	cursor: pointer;
	color: #75788b;
	margin: 1rem;
}

.statuses-container {
	display: flex;
	margin-top: 1rem;
}

.status-btn {
	padding: 1rem 2rem;
	border-radius: 10px;
	border: none;
	outline: none;
	cursor: pointer;
	margin-right: 1rem;
}

.btn-green {
	background: #7ad38d;
	color: white;
}

.btn-yellow {
	background: #ffbb56;
	color: white;
}

.btn-red {
	background: #e86363;
	color: white;
}
/* Dashboard end */

.table-container {
	width: 100%;
	overflow-x: auto;
	padding: 0 2rem;
	/* max-width: 1800px; */
	margin: 0 auto;
	transition: all 300ms ease;
}

table {
	width: 90%;
	border-collapse: collapse;
	text-align: center;
	margin: 0 auto 2rem;
	overflow-x: auto;
	/* border-bottom: 1px solid black; */
}

thead {
	background: #b8bac9;
	height: 70px;
}

thead th:nth-child(1) {
	border-top-left-radius: 10px;
}

thead th:nth-child(6) {
	border-top-right-radius: 10px;
}

th {
	padding: 1rem;
	color: #565656;
}

tr {
	cursor: pointer;
	transition: all 300ms ease;
}

tbody tr:hover {
	background: #f3f5ff;
}

tr:nth-child(even) {
	background: #b8bac9;
}

td {
	padding: 1rem;
	text-align: center;
	/* border: 1px solid #E3E3E3; */
}

.show-more-data {
	padding: 1rem 2rem;
	display: block;
	margin: 0 auto 2rem;
	border-radius: 25px;
	/* background: rgba(0, 231, 255, 0.9); */
	color: #fff;
	cursor: pointer;
}

@media only screen and (max-width: 1366px) {
	.dashboard-container {
		grid-template-columns: 1fr;
	}
}
</style>
